module.exports = "/images/vendor/flag-icon-css/flags/1x1/id.svg?9f708fe5bf604f5bf38ad5ca2c00c14b";